interface Props {
  percent: number;
  label?: string | null;
}

export function ProgressBar({ percent, label }: Props) {
  return (
    <div>
      <div className="mb-2 flex items-center justify-between text-xs text-slate-500">
        <span>{label ?? 'Working…'}</span>
        <span className="font-semibold text-ink">{percent}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-line">
        <div
          className="h-full rounded-full bg-brand transition-all duration-500"
          style={{ width: `${Math.max(3, percent)}%` }}
        />
      </div>
    </div>
  );
}
